import type { Translatable } from "../translations/translation";

type HttpErrorExtraData = {
    innerError?: Error;
    /**
     * An optional deeper explanation NOT TO BE shown in UI to end users
     * @type {Translatable}
     */
    explanation?: string;
    /**
         public reasonCode = "unknown",
         * Public title for reason about what went wrong that can be shown to
         * end users of the application
         * @type {Translatable}
         */
    reasonTitle?: Translatable;
    errorCode?: string;
    references?: Record<string, string | undefined>;
    extra?: unknown;
};

class HttpError extends Error {
    constructor(
        /**
         * Http status code
         * @type {Translatable}
         */
        public status: number,
        /**
         * Public message about what went wrong that can be shown to
         * end users of the application
         * @type {Translatable}
         */
        public reason: Translatable,
        public data?: HttpErrorExtraData,
        public sentryLogDisabled = false,
    ) {
        super(
            typeof reason === "string"
                ? reason
                : !reason
                  ? "okänt fel"
                  : (reason.sv ?? reason?.en ?? "okänt fel"),
        );
    }
}

export { HttpError };
export type { HttpErrorExtraData };
